import { MDText } from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';

import { usePageRefEvents } from '../../../../common/Hooks/usePageRefEvents';
import { RoundedSection } from '../../../../common/RoundedSection/RoundedSection';
import { carPrizeDrawSectionLoadEvent, TERMS_LINK } from '../CarPrizeDraw.helpers';

import Texts from './EligibilityAndEntryCriteria.texts.json';

import styles from './EligibilityAndEntryCriteria.module.scss';

const LocalT = new MDText(Texts);

export const EligibilityAndEntryCriteria = () => {
  const link = <Hyperlink href={TERMS_LINK} label={Texts.clickHere} size="large" underline={false} />;

  const onRefTrigger = () => carPrizeDrawSectionLoadEvent(LANDING_PAGE_SECTIONS_NAMES.ELIGIBILITY_CRITERIA);

  const { setRef } = usePageRefEvents({ onRefTrigger });

  return (
    <RoundedSection withBottomLedge withTopLedge theme="off-white">
      <div ref={(ref) => setRef(ref)} className={styles.component} data-testid="eligibilityAndEntryCriteria">
        <h2 className={styles.title}>{Texts.title}</h2>
        <div className={styles.body}>
          <p>{Texts.body.p1}</p>
          <p>{Texts.body.p2}</p>
        </div>
        <p data-thc-style-override className={styles.termsLink}>{LocalT.translate('termsConditions', { link })}</p>
      </div>
    </RoundedSection>
  );
};
